import {ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Field} from '@app/interfaces';
import dayjs from 'dayjs';
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    selector: 'app-form-input-date-time',
    templateUrl: './form-input-date-time.component.html',
    styleUrls: ['./form-input-date-time.component.scss'],
    standalone: false
})
export class FormInputDateTimeComponent implements OnChanges, OnInit, OnDestroy {

  @Input() control: AbstractControl;

  @Input() field: Field<string>;

  private destroy$ = new Subject<void>();
  public minDate: string;

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.control.statusChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.cdr.detectChanges();
      });

    if(this.field.config.minDate) {
      this.minDate = this.field.config.minDate;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.field.currentValue) {
      if (this.field.config.defaultToNow) {
        if (this.field.value === null) {
          this.control.setValue(dayjs());
        }
      }
    }
  }

  onPicklistChange(days: number) {
    // Only works if compareToField is set (e.g., auction_end_date)
    if (this.field.config.compareToField && this.control.parent) {
      const startControl = this.control.parent.get(this.field.config.compareToField);
      if (startControl && startControl.value) {
        const newDate = dayjs(startControl.value).add(days, 'day');
        this.control.setValue(newDate.format('YYYY-MM-DDTHH:mm'));
        this.control.markAsDirty();
        this.control.markAsTouched();
      }
    }
  }

}
